import { Component, Input, EventEmitter, Output, OnChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { isFunction } from 'lodash';

@Component({
	selector: 'calendar-select-filter-component',
	templateUrl: 'select-filter.component.html',
	styleUrls: ['./select-filter.component.scss'],
})
export class CalendarSelectFilterComponent implements OnChanges {
	@Input() public input:
		| (() => Promise<Array<{ name: string; value: string | number | boolean }>>)
		| Array<{ name: string; value: string | number | boolean }>;
	@Input() public translationKey: string;
	@Input() public multiple: boolean = true;
	@Input() public useTranslation: boolean = true;
	@Output() public readonly filter: EventEmitter<Array<string | number | boolean>> = new EventEmitter();

	public data: Array<{ name: string; value: string | number | boolean }> = new Array();
	public selectOptions: { [key: string]: any };
	public usingLocalData: boolean = true;

	constructor(public readonly translateService: TranslateService) {}

	public ngOnChanges(): void {
		this.selectOptions = {
			header: this.translateService.instant(`FILTERS.${this.translationKey}.TITLE`),
			message: this.translateService.instant(`FILTERS.${this.translationKey}.MESSAGE`),
		};
		this.getFilterData();
	}

	public async getFilterData(): Promise<void> {
		if (isFunction(this.input)) {
			this.usingLocalData = false;
			this.data = await (
				this.input as () => Promise<Array<{ name: string; value: string | number | boolean }>>
			)();
		} else this.data = this.input as Array<{ name: string; value: string | number | boolean }>;
	}

	public filterData(_selections: Array<string | number | boolean>): void {
		this.filter.emit(_selections);
	}
}
